type CheckboxOption = {
  label: string;
  value: string;
};

type CheckboxProps = {
  options: CheckboxOption[];
  selectedValues: string[];
  onChange: (selectedValues: string[]) => void;
  className?: string;
};

export const Checkbox = ({
  options,
  selectedValues,
  onChange,
  className,
}: CheckboxProps) => {
  const handleCheckboxChange = (value: string) => {
    if (selectedValues.includes(value)) {
      onChange(
        selectedValues.filter((selectedValue) => selectedValue !== value)
      );
    } else {
      onChange([...selectedValues, value]);
    }
  };

  return (
    <div className={`${className ?? "flex flex-col gap-4"}`}>
      {options.map((option) => (
        <label key={option.value} className="flex items-center gap-2">
          <input
            type="checkbox"
            value={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
            className="w-4 h-4"
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};
